<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__payrecord}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="工厂/供应商：">
          <el-input
            v-model="dataForm.companyName"
            placeholder="请输入工厂/供应商名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="reload()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="showSaveCode()" type="primary"
            >上传发票号</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button @click="showPayDialog()" type="warning"
            >批量付款</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :selectable="selectableHandle"
        ></el-table-column>
<!--        <el-table-column-->
<!--            prop="id"-->
<!--            label="工厂/供应商"-->
<!--            header-align="center"-->
<!--            align="center"-->
<!--        ></el-table-column>-->
        <el-table-column
          prop="companyName"
          label="工厂/供应商"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="合同号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="原料/成品" header-align="center">
          <template slot-scope="scope">
            <div>品名：{{ scope.row.productName }}</div>
            <div v-if="scope.row.color">颜色：{{ scope.row.color }}</div>
            <div v-if="scope.row.size">尺寸/规格：{{ scope.row.size }}</div>
            <div v-if="scope.row.attr1">幅宽：{{ scope.row.attr1 }}</div>
            <div v-if="scope.row.attr2">克重：{{ scope.row.attr2 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          prop="count"
          align="center"
          header-align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column label="总价" header-align="center" width="140" align="center">
          <template slot-scope="scope">
            <div>{{ moneyFormat(scope.row.amount) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="storeTime"
          label="收货日期"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="receiptCode"
          label="发票号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop=""
          label="付款信息"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
          <div>{{scope.row.accountName}}</div>
          <div>{{scope.row.accountNo}}</div>
        </template>
        </el-table-column>
        <el-table-column
          prop="imgs"
          label="付款凭证"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imgArr && scope.row.imgArr.length > 0"
              class="w-20 h-20"
              fit="contain"
              :src="scope.row.imgArr[0]"
              :preview-src-list="scope.row.imgArr"
            />
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="status"-->
<!--          label="处理状态"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag type="primary">-->
<!--              {{ $dictFormat("pay_record_status", scope.row.status) }}</el-tag-->
<!--            >-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
    <SaveCode ref="saveCode" @refreshDataList="getDataList"></SaveCode>
    <PayDialog ref="payDialog" @refreshDataList="getDataList"></PayDialog>
  </el-card>
</template>

<script>
// 待付账款
import mixinViewModule from "@/mixins/view-module";
import SaveCode from "./save-code";
import PayDialog from "./pay-dialog";
import moment from "moment";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/payrecord/page",
        getDataListIsPage: true,
        exportURL: "/trade/payrecord/export",
        deleteURL: "/trade/payrecord",
        deleteIsBatch: true,
      },
      dataForm: {
        payType: 2,
        factoryName: "",
        companyName: "",
      },
    };
  },
  methods: {
    selectableHandle(row, index) {
      console.log('selectableHandle',row)
      if (row.status == 20) {
        return false;
      }
      return true;
    },
    dateFormat(date) {
      if (!date) {
        return;
      }
      return moment(date).format("yyyy-MM-DD");
    },
    beforeTableBinding(dataList) {
      dataList.forEach((item) => {
        if (item.imgs) {
          item.imgArr = item.imgs.split(",");
        }
      });
    },
    showSaveCode() {
      if (this.dataListSelections.length === 0) {
        return this.$message.error("请选择对应记录");
      }
      const ids = this.dataListSelections.map((item) => item.id);
      this.$refs.saveCode.ids = ids;
      this.$refs.saveCode.init();
    },
    showPayDialog() {
      if (this.dataListSelections.length === 0) {
        return this.$message.error("请选择对应记录");
      }
      this.$store.state.waitPayList=this.$clone(this.dataListSelections)
      this.$refs.payDialog.init();
    },
  },
  components: { SaveCode, PayDialog },
};
</script>
